var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.back}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(" mdi-backspace ")]),_vm._v(" BACK ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }